import {BaseEntity} from "../base-entity";
import {Address} from "../../shared/address";
import {AddressTypes} from "../../shared/address-types";

export class Account extends BaseEntity{
    id : number;
    publicAccountId: number;
    name: string;
    firmName: string; //should display firmName instead of name
    addresses : Address[];
    legalFirmId : number;


    constructor(account?: Account) {
        super(account);
        if (account) {

            this.addresses = [];
            if (Array.isArray(account.addresses)) {
                for (let i: number = 0; i < account.addresses.length; i++) {
                    this.addresses[i] = new Address(account.addresses[i]);
                }
            }
        }
    }

    get mailingAddress() : Address {
        return this.addresses.find( item => item.addressTypeCode === AddressTypes.mailing)
    }
}